'use client'

import type { ProductListItem } from 'product-list/types/ProductsList'
import React, { type ReactNode, useEffect, useMemo, useRef } from 'react'

import { useInspirationalProvider } from '../../context/InspirationalProvider/useInspirationalProvider'

type Props = {
	productId: ProductListItem['id']
	colorId: ProductListItem['colorId']
	children: ReactNode
}

export const Cell = ({ productId, colorId, children }: Props) => {
	const cellRef = useRef<HTMLDivElement>(null)
	const { referrerInfo } = useInspirationalProvider()

	const haveRestorePosition = useMemo(
		() =>
			referrerInfo.product &&
			referrerInfo.product.id === productId &&
			referrerInfo.product.colorId === colorId,
		[productId, colorId, referrerInfo]
	)

	useEffect(() => {
		if (haveRestorePosition) {
			cellRef.current?.scrollIntoView({
				behavior: 'instant',
				block: 'center',
			})
		}
	}, [haveRestorePosition])

	return (
		<div
			ref={cellRef}
			itemProp='itemListElement'
			itemScope
			itemType='https://schema.org/ListItem'
		>
			{children}
		</div>
	)
}
